<template>
  <router-view />
</template>
<script>
  export default {
    name: 'AssociadoModule',
  }
</script>
